var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "data-title" }, [
            _vm._m(0),
            _c("div", { staticClass: "title-btn" }, [
              _c(
                "div",
                { staticClass: "title-btn-item", on: { click: _vm.openAdiog } },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("发起新交接")]),
                ]
              ),
            ]),
          ]),
          _c("lb-table", {
            attrs: {
              column: _vm.column,
              data: _vm.tableList,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "pop-handover",
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: "发起新交接",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "elForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "100px",
                    label: "把审批流程交接出去的人（被交接人）",
                    prop: "person1",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      key: "main",
                      staticClass: "select-u",
                      attrs: {
                        "value-key": "name",
                        placeholder: "请选择被交接人",
                        "collapse-tags": "",
                        size: "medium",
                        multiple: "",
                        "popper-class": "hidden",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.openUserPicker("person1")
                        },
                      },
                      model: {
                        value: _vm.person1,
                        callback: function ($$v) {
                          _vm.person1 = $$v
                        },
                        expression: "person1",
                      },
                    },
                    _vm._l(_vm.person1, function (person, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: person.serial + " " + person.name,
                          value: person,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.form.person1
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "100px",
                        label: "接收审批流程的人（交接人）",
                        prop: "person2",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          key: "main",
                          staticClass: "select-u",
                          attrs: {
                            "value-key": "name",
                            placeholder: "请选择交接人",
                            "collapse-tags": "",
                            size: "medium",
                            multiple: "",
                            "popper-class": "hidden",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.openUserPicker("person2")
                            },
                          },
                          model: {
                            value: _vm.person2,
                            callback: function ($$v) {
                              _vm.person2 = $$v
                            },
                            expression: "person2",
                          },
                        },
                        _vm._l(_vm.person2, function (person, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: person.serial + " " + person.name,
                              value: person,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.person2
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "100px",
                        label: "生效审批模板",
                        prop: "templateIds",
                      },
                    },
                    [
                      _vm.templateNames
                        ? _c(
                            "div",
                            {
                              staticClass: "select-wrap",
                              on: {
                                click: function ($event) {
                                  return _vm.onFlow("add")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "select-names" }, [
                                _vm._v(_vm._s(_vm.templateNames)),
                              ]),
                              _c("i", {
                                staticClass:
                                  "icon-down el-select__caret el-input__icon el-icon-arrow-down",
                              }),
                            ]
                          )
                        : _c("el-select", {
                            staticClass: "select-all",
                            attrs: {
                              value: _vm.form.templateIds,
                              size: "medium",
                              "popper-class": "hidden",
                              placeholder: "请选择审批模版",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.onFlow("add")
                              },
                            },
                          }),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v(
                          "选中的审批模板中，“被交接人”的审批节点替换为“交接人”"
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: { click: _vm.subForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "pop-handover",
          attrs: {
            visible: _vm.dialogFlowVisible,
            "append-to-body": true,
            title: "审批模版",
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFlowVisible = $event
            },
          },
        },
        [
          _c("div", { class: "flow-form flow-form-" + _vm.dialogType }, [
            _c("div", { staticClass: "flow-1" }, [
              _c("div", { staticClass: "flow-head" }, [_vm._v("审批单")]),
              _vm.dialogType == "look"
                ? _c(
                    "div",
                    { staticClass: "flow-list" },
                    [
                      _vm.lookDetail.approvalForms.length > 0
                        ? _vm._l(
                            _vm.lookDetail.approvalForms,
                            function (item, index) {
                              return _c("div", { key: index }, [
                                _c(
                                  "div",
                                  { staticClass: "group-name ellipsis" },
                                  [_vm._v(_vm._s(item.groupName))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "group-con" },
                                  _vm._l(
                                    item.templates,
                                    function (template, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "item-name ellipsis",
                                        },
                                        [_vm._v(_vm._s(template.name))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            }
                          )
                        : [_vm._v(" 无 ")],
                    ],
                    2
                  )
                : _vm.dialogType == "add"
                ? _c(
                    "div",
                    { staticClass: "flow-tree" },
                    [
                      _c("el-tree", {
                        ref: "approvalFormsTree",
                        attrs: {
                          "empty-text": "该用户没有相关审批单",
                          data: _vm.approvalForms,
                          "show-checkbox": "",
                          "node-key": "id",
                          "default-checked-keys": _vm.approvalFormsIds,
                          "default-expand-all": true,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "flow-2" }, [
              _c("div", { staticClass: "flow-head" }, [_vm._v("审批流")]),
              _vm.dialogType === "look"
                ? _c(
                    "div",
                    { staticClass: "flow-list" },
                    [
                      _vm.lookDetail.approvalFlows.length > 0
                        ? _vm._l(
                            _vm.lookDetail.approvalFlows,
                            function (item, index) {
                              return _c("div", { key: index }, [
                                _c(
                                  "div",
                                  { staticClass: "group-name ellipsis" },
                                  [_vm._v(_vm._s(item.groupName))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "group-con" },
                                  _vm._l(
                                    item.templates,
                                    function (template, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "item-name ellipsis",
                                        },
                                        [_vm._v(_vm._s(template.name))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            }
                          )
                        : [_vm._v(" 无 ")],
                    ],
                    2
                  )
                : _vm.dialogType === "add"
                ? _c(
                    "div",
                    { staticClass: "flow-tree" },
                    [
                      _c("el-tree", {
                        ref: "approvalFlowsTree",
                        attrs: {
                          "empty-text": "该用户没有相关审批流",
                          data: _vm.approvalFlows,
                          "show-checkbox": "",
                          "node-key": "id",
                          "default-checked-keys": _vm.approvalFlowsIds,
                          "default-expand-all": true,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFlowVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm.dialogType === "add"
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.update } },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "选择成员", multiple: false },
        on: { ok: _vm.selectedUser },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
      _c("div", { staticClass: "title-line" }),
      _c("div", { staticClass: "title-name" }, [_vm._v("审批流程交接")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }